import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=1ec3401f&scoped=true&"
import script from "./CodeHighlight.vue?vue&type=script&lang=js&"
export * from "./CodeHighlight.vue?vue&type=script&lang=js&"
import style0 from "./CodeHighlight.vue?vue&type=style&index=0&id=1ec3401f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3401f",
  null
  
)

export default component.exports